var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 34.375C14.8742 34.369 16.8379 33.6081 18.333 32.2437L32.9397 40.441C31.928 44.3237 33.9722 48.3471 37.7393 49.8877C41.5064 51.4284 45.8539 50.0191 47.9471 46.5787C50.0403 43.1384 49.2443 38.7104 46.0781 36.182C42.9119 33.6537 38.3359 33.7917 35.3337 36.5062L20.727 28.309C20.8802 27.7339 20.9647 27.1432 20.979 26.549L35.3314 18.4937C38.1801 21.0373 42.4537 21.2732 45.5746 19.059C48.6956 16.8449 49.8106 12.7862 48.2472 9.33071C46.6838 5.87522 42.8695 3.96779 39.1047 4.75879C35.3398 5.54978 32.6539 8.8229 32.6667 12.6042C32.675 13.2643 32.7667 13.921 32.9397 14.559L19.677 22C17.5525 18.772 13.3951 17.478 9.7653 18.915C6.13553 20.352 4.05395 24.116 4.80265 27.8886C5.55135 31.6613 8.91983 34.382 12.8334 34.375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/ShareIcon.2621316f47ffaa5f149417924f05d9d8.svg";
export { ForwardRef as ReactComponent };